import { render, staticRenderFns } from "./AddReportComp.vue?vue&type=template&id=fb24579c&"
import script from "./AddReportComp.vue?vue&type=script&lang=js&"
export * from "./AddReportComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports